
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenWeatherCategoryMetrics } from './GenWeatherCategoryMetrics';
import { GenWeatherCurve } from './GenWeatherCurve';
import { GenWeatherEpisode } from './GenWeatherEpisode';
import { GenWeatherEvent } from './GenWeatherEvent';
import { GenWeatherMetrics } from './GenWeatherMetrics';

export class GenWeatherCountyDetail {

    all: GenWeatherMetrics;
    categories: GenWeatherCategoryMetrics[];
    category: string;
    county: string;
    coverageYears: number[];
    curves: GenWeatherCurve[];
    datasetVersion: string;
    dominantCategory: string;
    episodes: GenWeatherEpisode[];
    events: GenWeatherEvent[];
    fips: string;
    highestMedianBurdenCategory: string;
    highestMedianBurdenCategoryAll: string;
    highestMedianBurdenValue: number;
    highestMedianBurdenValueAll: number;
    highestMedianPeakCategory: string;
    highestMedianPeakCategoryAll: string;
    highestMedianPeakValue: number;
    highestMedianPeakValueAll: number;
    longestMedianRecoveryCategory: string;
    longestMedianRecoveryCategoryAll: string;
    longestMedianRecoveryValue: number;
    longestMedianRecoveryValueAll: number;
    metrics: GenWeatherMetrics;
    outageAssociatedCategory: string;
    outageAssociatedCategoryEventCount: number;
    outageAssociatedCategoryTie: boolean;
    state: string;
    studyPeriod: string;
    totalCustomers: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genWeatherCountyDetail: GenWeatherCountyDetail);

    constructor( input?: GenWeatherCountyDetail ) {
        if ( input && typeof input !== 'number' ) {
            if( input.all ) {
              this.all = new GenWeatherMetrics( input.all );
            }
            if ( input.categories && input.categories.map ) { // list [GenWeatherCategoryMetrics]
                this.categories = input.categories.map( ( x: GenWeatherCategoryMetrics ) => {
                    return new GenWeatherCategoryMetrics( x );
                } );
            } else {
                this.categories = input.categories;
            }
            this.category = input.category; // string [string]
            this.county = input.county; // string [string]
            this.coverageYears = input.coverageYears; // list [number]
            if ( input.curves && input.curves.map ) { // list [GenWeatherCurve]
                this.curves = input.curves.map( ( x: GenWeatherCurve ) => {
                    return new GenWeatherCurve( x );
                } );
            } else {
                this.curves = input.curves;
            }
            this.datasetVersion = input.datasetVersion; // string [string]
            this.dominantCategory = input.dominantCategory; // string [string]
            if ( input.episodes && input.episodes.map ) { // list [GenWeatherEpisode]
                this.episodes = input.episodes.map( ( x: GenWeatherEpisode ) => {
                    return new GenWeatherEpisode( x );
                } );
            } else {
                this.episodes = input.episodes;
            }
            if ( input.events && input.events.map ) { // list [GenWeatherEvent]
                this.events = input.events.map( ( x: GenWeatherEvent ) => {
                    return new GenWeatherEvent( x );
                } );
            } else {
                this.events = input.events;
            }
            this.fips = input.fips; // string [string]
            this.highestMedianBurdenCategory = input.highestMedianBurdenCategory; // string [string]
            this.highestMedianBurdenCategoryAll = input.highestMedianBurdenCategoryAll; // string [string]
            this.highestMedianBurdenValue = input.highestMedianBurdenValue; // float [number]
            this.highestMedianBurdenValueAll = input.highestMedianBurdenValueAll; // float [number]
            this.highestMedianPeakCategory = input.highestMedianPeakCategory; // string [string]
            this.highestMedianPeakCategoryAll = input.highestMedianPeakCategoryAll; // string [string]
            this.highestMedianPeakValue = input.highestMedianPeakValue; // float [number]
            this.highestMedianPeakValueAll = input.highestMedianPeakValueAll; // float [number]
            this.longestMedianRecoveryCategory = input.longestMedianRecoveryCategory; // string [string]
            this.longestMedianRecoveryCategoryAll = input.longestMedianRecoveryCategoryAll; // string [string]
            this.longestMedianRecoveryValue = input.longestMedianRecoveryValue; // float [number]
            this.longestMedianRecoveryValueAll = input.longestMedianRecoveryValueAll; // float [number]
            if( input.metrics ) {
              this.metrics = new GenWeatherMetrics( input.metrics );
            }
            this.outageAssociatedCategory = input.outageAssociatedCategory; // string [string]
            this.outageAssociatedCategoryEventCount = input.outageAssociatedCategoryEventCount; // int [number]
            this.outageAssociatedCategoryTie = input.outageAssociatedCategoryTie; // boolean [boolean]
            this.state = input.state; // string [string]
            this.studyPeriod = input.studyPeriod; // string [string]
            this.totalCustomers = input.totalCustomers; // float [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenWeatherCountyDetail[] {
        if (arr && arr.map) {
          return arr.map(a => new GenWeatherCountyDetail(a));
        } else {
          return [];
        }
    }
}

